var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewListIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66699V25.3337H26.6667V6.66699H4ZM9.33333 9.33366V12.0003H6.66667V9.33366H9.33333ZM6.66667 17.3337V14.667H9.33333V17.3337H6.66667ZM6.66667 20.0003H9.33333V22.667H6.66667V20.0003ZM24 22.667H12V20.0003H24V22.667ZM24 17.3337H12V14.667H24V17.3337ZM24 12.0003H12V9.33366H24V12.0003Z",
    fill: "#646464"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewListIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/View_List_icon.72e57ca3e0a53d5c8fd16022d3f2133d.svg";